/* Redux saga class
 * logout the user from the app
 */
import { call } from 'redux-saga/effects';
import awsUserLogout from '../api/methods/awsUserLogout';
//import NavigationService from '../navigation/NavigationService';

// Our worker Saga that logout the user
export default function* logoutSaga() {
  try {
    yield call(awsUserLogout.logout);
    //NavigationService.navigate('SignIn');
  } catch (error) {
    console.log('logoutSaga:logoutSaga - Error signing out', error);
  }
}
